import axios from 'axios';
import React, { useState, useEffect } from 'react';
//import { Link } from 'react-router-dom'
import { Form, Button, Jumbotron, Container, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../components/Message';
import Loader from '../components/Loader';
// import FormContainer from '../components/FormContainer';
import { listSpaceDetails, updateSpace } from '../actions/spaceActions';
import { SPACE_UPDATE_RESET } from '../constants/spaceConstants';

const CreateSpaceScreen = ({ match, history }) => {
  const spaceId = match.params.id;

  const [gymName, setGymName] = useState('');
  const [price, setPrice] = useState(0);
  const [image, setImage] = useState('');
  const [classType, setClassType] = useState('');
  const [occupency, setOccupency] = useState('');
  const [classTime, setClassTime] = useState(0);
  const [classDates, setClassDates] = useState('');
  const [description, setDescription] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zip, setZip] = useState('');
  const [uploading, setUploading] = useState(false);

  const dispatch = useDispatch();

  const spaceDetails = useSelector(state => state.spaceDetails);
  const { loading, error, space } = spaceDetails;

  const spaceUpdate = useSelector(state => state.spaceUpdate);
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = spaceUpdate;

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: SPACE_UPDATE_RESET });
      history.push('/spacelist');
    } else {
      if (!space.gymName || space._id !== spaceId) {
        dispatch(listSpaceDetails(spaceId));
      } else {
        setGymName(space.gymName);
        setPrice(space.price);
        setImage(space.image);
        setClassType(space.classType);
        setOccupency(space.occupency);
        setClassTime(space.classTime);
        setClassDates(space.classDates);
        setDescription(space.description);
        setAddress1(space.address1);
        setAddress2(space.address2);
        setCity(space.city);
        setState(space.state);
        setZip(space.zip);
      }
    }
  }, [dispatch, history, spaceId, space, successUpdate]);

  const uploadFileHandler = async e => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('image', file);
    setUploading(true);

    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await axios.post('/api/upload', formData, config);

      setImage(data);
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  const submitHandler = e => {
    e.preventDefault();
    dispatch(
      updateSpace({
        _id: spaceId,

        gymName,
        price,
        image,
        classType,
        occupency,
        classTime,
        classDates,
        description,
        address1,
        address2,
        city,
        state,
        zip,
      })
    );
  };

  return (
    <>
      <Jumbotron className='jumbotron4'>
        <Container>
          <h1>Create a Space</h1>
        </Container>
      </Jumbotron>
      {loadingUpdate && <Loader />}
      {errorUpdate && <Message variant='danger'>{errorUpdate}</Message>}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <Form onSubmit={submitHandler}>
          <Form.Row>
            <Form.Group as={Col} controlId='gymName'>
              <Form.Label>Gym Name</Form.Label>
              <Form.Control
                required
                placeholder='What gym is hosting this class?'
                type='name'
                value={gymName}
                onChange={e => setGymName(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col} controlId='classType'>
              <Form.Label>Class Types Offered</Form.Label>
              <Form.Control
                required
                as='select'
                defaultValue='Choose...'
                type='text'
                value={classType}
                onChange={e => setClassType(e.target.value)}
              >
                <option>Choose one...</option>
                <option>Yoga</option>
                <option>CrossFit</option>
                <option>Barre</option>
                <option>Zumba</option>
                <option>Spin</option>
                <option>Cardio</option>
              </Form.Control>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId='occupency'>
              <Form.Label>Maximum Occupency</Form.Label>
              <Form.Control
                required
                type='number'
                placeholder='How big is your class?'
                value={occupency}
                onChange={e => setOccupency(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col} controlId='classTime'>
              <Form.Label>Class Time</Form.Label>
              <Form.Control
                type='time'
                placeholder='What time is class?'
                value={classTime}
                onChange={e => setClassTime(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col} controlId='classDates'>
              <Form.Label>Days Offered</Form.Label>
              <Form.Control
                type='date'
                placeholder='Pick a date...'
                value={classDates}
                onChange={e => setClassDates(e.target.value)}
              ></Form.Control>
            </Form.Group>
          </Form.Row>

          <Form.Group controlId='price'>
            <Form.Label>Price per person</Form.Label>
            <Form.Control
              required
              type='number'
              placeholder='How much does one class cost?'
              value={price}
              onChange={e => setPrice(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId='description'>
            <Form.Label>Give us a brief description of your space</Form.Label>
            <Form.Control
              as='textarea'
              required
              type='text'
              value={description}
              rows={3}
              onChange={e => setDescription(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId='address1'>
            <Form.Label>Address 1</Form.Label>
            <Form.Control
              required
              type='text'
              placeholder='1234 Real St.'
              value={address1}
              onChange={e => setAddress1(e.target.value)}
            />
          </Form.Group>
          <Form.Group controlId='address2'>
            <Form.Label>Address 2</Form.Label>
            <Form.Control
              placeholder='Apartment, studio, or floor'
              value={address2}
              onChange={e => setAddress2(e.target.value)}
            />
          </Form.Group>

          <Form.Row>
            <Form.Group as={Col} controlId='city'>
              <Form.Label>City</Form.Label>
              <Form.Control
                required
                type='text'
                value={city}
                onChange={e => setCity(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col} controlId='state'>
              <Form.Label>State</Form.Label>
              <Form.Control
                required
                as='select'
                defaultValue='Choose...'
                value={state}
                onChange={e => setState(e.target.value)}
              >
                <option>Choose...</option>
                <option>CA</option>
                <option>CO</option>
                <option>IL</option>
                <option>NM</option>
                <option>NY</option>
                <option>TX</option>
              </Form.Control>
            </Form.Group>

            <Form.Group as={Col} controlId='zip'>
              <Form.Label>Zip</Form.Label>
              <Form.Control
                required
                value={zip}
                onChange={e => setZip(e.target.value)}
              />
            </Form.Group>
          </Form.Row>

          <Form.Group>
            <Form.Label>Image</Form.Label>
            <Form.Control
              type='text'
              placeholder='Enter image url'
              value={image}
              onChange={e => setImage(e.target.value)}
            ></Form.Control>
            <Form.File
              id='image-file'
              label='Choose File'
              custom
              onChange={uploadFileHandler}
            ></Form.File>
            {uploading && <Loader />}
          </Form.Group>

          <Form.Group id='checkbox'>
            <Form.Check
              required
              type='checkbox'
              label='I agree to the Terms and Conditions'
            />
          </Form.Group>

          <Button variant='primary' type='submit'>
            Create Space
          </Button>
        </Form>
      )}
    </>
  );
};

export default CreateSpaceScreen;
